import { icons } from "@/shahrzad-assets/shared-asstes/icons"
import { colors } from "@/shahrzad-assets/shared-constants/colors"
import { dimens } from "@/shahrzad-assets/shared-constants/dimens"
import { fontSize } from "@/shahrzad-assets/shared-constants/fonts"
import styled from "styled-components"

const ProfileFamilyFeatures = () => {
  return (
    <FeaturesList>
        <li>
          <div className='image-container'>
            <img src={icons.WHITE_WALLET} alt='icon' />
          </div>
          <div className='texts'>
            <h4 className='title'>کیف پول</h4>
            <p>خرید از تره بار، فروشگاه شهروند ...</p>
          </div>
        </li>
        <li>
          <div className='image-container'>
            <img src={icons.WHITE_TICKET} alt='icon' />
          </div>
          <div className='texts'>
            <h4 className='title'>بلیت مترو و BRT</h4>
            <p>خرید و ثبت بلیت‌های اقشار خاص و تخصیص به بقیه اعضا</p>
          </div>
        </li>
    </FeaturesList>
  )
}

export default ProfileFamilyFeatures

const FeaturesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${dimens.SPACING_XL};

  li {
    display: flex;
    align-items: center;
    gap: ${dimens.SPACING_XS};

    .image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2rem;
      aspect-ratio: 1;
      border-radius: ${dimens.BORDER_RADIUS_CIRCLE};
      background-color: ${colors.primaryBrandTextHover};
    }

    .texts p {
      margin-top: ${dimens.SPACING_XXS_NUDGE};
      font-size: ${fontSize.SMALL};
      color: ${colors.text3};
    }
  }
`